import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReorderRuleExportConfigurationContext } from '../../../../../../../../context/ReorderRuleExportConfigurationContext';
import DeleteModal from '../../../../../../../../VentoryUI/components/common/Modal/DeleteModal';
import { useRequest } from '../../../../../../../../requests/common/requestHook';
import { ReorderRuleExportConfigurationRequest } from '../../../../../../../../requests/reorderRuleExportConfiguration.request';
import { Routing } from '../../../../../../../../util/routes.util';
import {
  DeleteReorderRuleExportConfigurationInput,
  ReorderRuleExportConfigurationInput,
} from '../../../../../../../../types/reorder_rule_export_configuration';

interface DeleteReorderRuleExportConfigurationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  ids: Set<string>;
}

export default function DeleteReorderRuleExportConfigurationModal({
  open,
  setOpen,
  ids,
}: DeleteReorderRuleExportConfigurationModalProps) {
  const navigate = useNavigate();

  const { reorderRuleExportConfigurations, setReorderRuleExportConfigurations } = useContext(
    ReorderRuleExportConfigurationContext,
  );

  const [remove, { loading }] = useRequest(ReorderRuleExportConfigurationRequest.remove);

  const handleDelete = async () => {
    const toDelete: DeleteReorderRuleExportConfigurationInput[] = [];

    for (const id of ids) {
      const config = reorderRuleExportConfigurations.get(id);
      if (config) toDelete.push(new ReorderRuleExportConfigurationInput(config).forDelete());
    }

    const result = await remove({ data: toDelete });
    if (!result) return;

    for (const config of result) {
      reorderRuleExportConfigurations.delete(config.id);
    }

    setReorderRuleExportConfigurations(new Map(reorderRuleExportConfigurations));
    handleClose();
    navigate(Routing.productMasterData.settings.stockTriggers.settings.report.overview());
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <DeleteModal
      text={'Are you sure you want to delete this reorderRule export configuration?'}
      onConfirm={handleDelete}
      open={open}
      onClose={handleClose}
      loading={loading}
    />
  );
}
